let httpContent = process.env.VUE_APP_BASE_URL; // 请求接口 根据环境变量  运营后台
const httpContentPc = process.env.VUE_APP_BASE_URL_PC; // 请求接口 根据环境变量 官网
const httpContentIndexPc = process.env.VUE_APP_BASE_URL_OLD; // 请求接口 根据环境变量 首页
const httpContentBox = process.env.VUE_APP_BASE_URL_BOX; // 请求接口 根据环境变量 官网
let httpContentHome = process.env.VUE_APP_BASE_URL_OPENAPI; // 请求接口 根据环境变量 官网
const httpContentSdk = process.env.VUE_APP_BASE_URL_SDK; // SDK-java接口
// 是否为开发环境
if (process.env.NODE_ENV === "development") {
  httpContent = "http://managerapi-dev.dhsf.xqhuyu.com";
  httpContentHome = ""
}
export default {
  homes: {
    // 获取下载链接
    getGameLink: `https://tgdata.996box.com/down_url.json`,
    // 新前台日志管理接口
    getUpdateLog: `${httpContent}/api/WebsiteLog/getUpdateLog`,
    // 新前台引擎管理接口
    getEngine: `${httpContent}/api/WebsiteLog/getEngine`,
    // 官网注册
    register: `${httpContentPc}/api/auth/register`,
    // 官网注册 获取验证码
    getCode: `${httpContentPc}/api/auth/code`,
    // 新游推荐
    newGameList: `${httpContentIndexPc}/v1/homeapi/Gameindex/NewGameList`,
    // 游戏详情
    gameInfo: `${httpContentIndexPc}/v1/homeapi/gameindex/gameInfo`,
    // 同厂推荐
    firmRecommend: `${httpContentIndexPc}/v1/homeapi/gameindex/firmRecommend`,
    // 官网首页游戏列表
    getRankTop: `${httpContentBox}/v1/homeapi/Gameindex/getRankTop`,
    // 获取更新日志json
    getUserJson: `https://static.dhsf.xqhuyu.com/offical/ysxy.json`,
    // 游戏列表
    getCooperationList: `${httpContentHome}/api/Cooperation/list`,
    // 获取新闻列表
    getNewsList: `${httpContentHome}/api/news/list`,
    // 获取新闻详情
    getNewsDetail: `${httpContentHome}/api/news/detail`,
    // 获取服务进程
    getProcess: `${httpContentHome}/api/Home/process`,
    // 获取技术文档
    getDoc: `${httpContentHome}/api/Home/doc`,
    // 获取分类 -- 潘逸炜
    classificationList: `${httpContentSdk}/open_api/official/versionCenter/v1/classification/list`,
    // 根据分类获取版本 -- 潘逸炜
    getVersion: `${httpContentSdk}/open_api/official/versionCenter/v1/version/page`,
    // 根据分类获取游戏类型 -- 潘逸炜
    gameType: `${httpContentSdk}/open_api/official/versionCenter/v1/version/gameType`,
    // 查看版本详情 -- 潘逸炜
    getVersionDetails: `${httpContentSdk}/open_api/official/versionCenter/v1/version`,
    // 下载 -- 潘逸炜
    versionDownload: `${httpContentSdk}/open_api/official/versionCenter/v1/version/download`,
    // 授权码校验 -- 周星宇
    purePcVerify: `${httpContentHome}/api/WebsiteManagement/purePcVerify`,
    // 临时证书 -- 周星宇
    purePcTmpCode: `${httpContentHome}/api/WebsiteManagement/purePcTmpCode`,
    // 官网注册
    getPurePcEngineDownloadUrl: `${httpContent}/api/WebsiteLog/getPurePcEngineDownloadUrl`,
  },
};
